import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import eaiLightTheme from './themes/eai-light-theme'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    default: 'eaiTheme',
    themes: {
      light: eaiLightTheme
    }
  }
})
